// src/services/transactions.js

import api from "./api";

/**
 * Fetches all data required for the Transactions page.
 */
export async function getTransactions(outletUid) {

    try {

        const response = await api.get(

            "/api/v1/nextgo/transactions",

            {

                params: {

                    outletUid,

                },

            }

        );

        return response.data;

    }

    catch (error) {

        console.error(

            "Failed to fetch transactions:",

            error

        );

        throw error;

    }

}